import { Injectable }                   from '@angular/core';
import { ArchivingMapperService }       from '@http/archiving/archiving-mapper.service';
import { ContractsMapperService }       from '@http/contracts/contracts-mapper.service';
import { ErrorsMapperService }          from '@http/errors/errors-mapper.service';
import { ErsMapperService }             from '@http/ers/ers-mapper.service';
import { FccMapperService }             from '@http/fcc/fcc-mapper.service';
import { NotificationMapperService }    from '@http/notification/notification-mapper.service';
import { StructureImportMapperService } from '@http/structure-import/structure-import-mapper.service';
import { TaxationMapperService }        from '@http/taxation/taxation-mapper.service';
import { TssMapperService }             from '@http/tss/tss-mapper.service';
import { SalutationEnum }               from '@models/common.model';
import { SalutationEnumDTO }            from '@openApiGenerated/management-api';
import { LoggerService }                from '@shared/services/logger.service';

@Injectable( {
	providedIn: 'root'
} )
export class MapperService {

	constructor(
		private readonly _archivingMapperService: ArchivingMapperService,
		private readonly _contractsMapperService: ContractsMapperService,
		private readonly _errorsMapperService: ErrorsMapperService,
		private readonly _ersMapperService: ErsMapperService,
		private readonly _fccMapperService: FccMapperService,
		private readonly _logger: LoggerService,
		private readonly _notificationMapperService: NotificationMapperService,
		private readonly _structureImportMapperService: StructureImportMapperService,
		private readonly _taxationMapperService: TaxationMapperService,
		private readonly _tssMapperService: TssMapperService
	) {}


	get common() {
		return {
			salutationDtoToTmo: this.mapSalutationDtoToTmo.bind( this ) as typeof this.mapSalutationDtoToTmo,
			salutationTmoToDto: this.mapSalutationTmoToDto.bind( this ) as typeof this.mapSalutationTmoToDto
		};
	}

	get archiving() { return this._archivingMapperService.archiving; }

	get contracts() { return this._contractsMapperService.contracts; }

	get errors() { return this._errorsMapperService.errors; }

	get ers() { return this._ersMapperService.ers; }

	get fcc() { return this._fccMapperService.fcc; }

	get notification() { return this._notificationMapperService.notification; }

	get structureImport() { return this._structureImportMapperService.import; }

	get taxation() { return this._taxationMapperService.taxation; }

	get tss() { return this._tssMapperService.tss; }


	private mapSalutationDtoToTmo( salutation: SalutationEnumDTO ): SalutationEnum {
		switch ( salutation ) {
			case SalutationEnumDTO.MR:
				return SalutationEnum.MR;

			case SalutationEnumDTO.MRS:
				return SalutationEnum.MRS;

			case SalutationEnumDTO.OTHER:
				return SalutationEnum.OTHER;

			default:
				this._logger.warn( `mapSalutationDtoToTmo has no case for DTO ${ salutation }` );
				return null;
		}
	}

	private mapSalutationTmoToDto( salutation: SalutationEnum ): SalutationEnumDTO {
		switch ( salutation ) {
			case SalutationEnum.MR:
				return SalutationEnumDTO.MR;

			case SalutationEnum.MRS:
				return SalutationEnumDTO.MRS;

			case SalutationEnum.OTHER:
				return SalutationEnumDTO.OTHER;

			default:
				this._logger.warn( `mapSalutationTmoToDto has no case for TMO ${ salutation }` );
				return null;
		}
	}
}
